/* tslint:disable */
/* eslint-disable */
/**
 * Joule Conductor Cloud
 * This specification document describes the Joule Technologies Application Programming Interface  (API). The endpoints, message formats and status codes are explained in this document. ## Communication  ### Base URI  The base Uniform Resource Identifier (URI) is: https://user-api.joule-cloud.com/v2 This URI is the prefix for all endpoints described in this document. ### Body format  The endpoints of the API expecting a body must be in JavaScript Object Notation (JSON) format.  Response bodies from the endpoints also adhere to this standard, unless otherwise stated.  Responses will include a Content-Type header indicating the ‘application/json’ type. An invalid  or missing body will result in a 400-status code accompanied by an error code to specify the  nature of the error. ### Security The API uses HTTPS as the underlying protocol to transfer data. The server hosts a certificate  to set up a secure connection using Transport Layer Security (TLS) version 1.2. The authenticity  of the server certificate is verifiable by the client using publicly available sources.  #### Authentication and authorization  The API should only be called by legitimate users with the correct access rights. The API uses  the Open Authorization 2.0 (OAuth) standard to achieve this. Every request to the API should  include a bearer access token in the JSON Web Token (JWT) format in the Authorization header.  The header should be formatted such as in the example below.  ```   {“Authorization”: “Bearer <JWT>”}  ``` The JWT must be acquired from one of the following identity providers:   * joule-technologies.eu.auth0.com    * inventum-app.eu.auth0.com    * joule-app.eu.auth0.com   For help regarding gaining an access token you can find the docs for Auth0  [here](https://auth0.com/docs/secure/tokens/access-tokens/get-access-tokens). The JWT must be intended for one of the following audiences:    * https://user-api.joule-cloud.com   If the authorization header does not match the requirements stated above the API will respond  with a 401-status code accompanied by an error code to specify the nature of the error.  ### Timeout The API specifies a maximum amount of time between a request and the response to avoid blocking  either side. The general timeout that has been set for each endpoint is 3000 milliseconds.  This timeout is used unless otherwise stated in the respective endpoint documentation.  If the server is unable to respond within this maximum time, the response contains a 504-status  code. The client may retry the request. The time out for a stream to be open is 1800 seconds.  If the stream is still open passed the experitation the server will close the stream. ### Rate limits  No rate limit is currently imposed. ### Diagnostics response  The diagnostics response provides the caller of the API with more information in case of a  failed request. This information can be used for debugging and recovery/retrying purposes.  The diagnostics response is always included under the “diagnostics” key if the response  has a body. 
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FirmwareResponse
 */
export interface FirmwareResponse {
    /**
     * 
     * @type {FirmwareResponseBoardTypeEnum}
     * @memberof FirmwareResponse
     */
    boardType?: FirmwareResponseBoardTypeEnum;
    /**
     * 
     * @type {Array<FirmwareResponse>}
     * @memberof FirmwareResponse
     */
    children?: Array<FirmwareResponse>;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    deviceType?: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    firmwareId?: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    name?: string;
    /**
     * 
     * @type {FirmwareResponseTypeEnum}
     * @memberof FirmwareResponse
     */
    type?: FirmwareResponseTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    uri?: string;
    /**
     * 
     * @type {string}
     * @memberof FirmwareResponse
     */
    version?: string;
}


/**
 * @export
 */
export const FirmwareResponseBoardTypeEnum = {
    Hph200: 'HPH200',
    Hpc200: 'HPC200',
    Hpp200: 'HPP200',
    Hpx200: 'HPX200',
    Zigbee: 'ZIGBEE',
    Bv180: 'BV180'
} as const;
export type FirmwareResponseBoardTypeEnum = typeof FirmwareResponseBoardTypeEnum[keyof typeof FirmwareResponseBoardTypeEnum];

/**
 * @export
 */
export const FirmwareResponseTypeEnum = {
    Group: 'GROUP',
    Version: 'VERSION',
    Set: 'SET',
    Boardversion: 'BOARDVERSION'
} as const;
export type FirmwareResponseTypeEnum = typeof FirmwareResponseTypeEnum[keyof typeof FirmwareResponseTypeEnum];


/**
 * Check if a given object implements the FirmwareResponse interface.
 */
export function instanceOfFirmwareResponse(value: object): value is FirmwareResponse {
    return true;
}

export function FirmwareResponseFromJSON(json: any): FirmwareResponse {
    return FirmwareResponseFromJSONTyped(json, false);
}

export function FirmwareResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FirmwareResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'boardType': json['board_type'] == null ? undefined : json['board_type'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(FirmwareResponseFromJSON)),
        'deviceType': json['device_type'] == null ? undefined : json['device_type'],
        'firmwareId': json['firmware_id'] == null ? undefined : json['firmware_id'],
        'name': json['name'] == null ? undefined : json['name'],
        'type': json['type'] == null ? undefined : json['type'],
        'uri': json['uri'] == null ? undefined : json['uri'],
        'version': json['version'] == null ? undefined : json['version'],
    };
}

export function FirmwareResponseToJSON(json: any): FirmwareResponse {
    return FirmwareResponseToJSONTyped(json, false);
}

export function FirmwareResponseToJSONTyped(value?: FirmwareResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'board_type': value['boardType'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(FirmwareResponseToJSON)),
        'device_type': value['deviceType'],
        'firmware_id': value['firmwareId'],
        'name': value['name'],
        'type': value['type'],
        'uri': value['uri'],
        'version': value['version'],
    };
}

